var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5002 10.8441C8.06284 10.8441 8.51895 10.388 8.51895 9.82539C8.51895 9.26275 8.06284 8.80664 7.5002 8.80664C6.93756 8.80664 6.48145 9.26275 6.48145 9.82539C6.48145 10.388 6.93756 10.8441 7.5002 10.8441Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.425 5.95625V5.175C11.425 3.4875 11.0188 1.25 7.5 1.25C3.98125 1.25 3.575 3.4875 3.575 5.175V5.95625C1.825 6.175 1.25 7.0625 1.25 9.24375V10.4062C1.25 12.9688 2.03125 13.75 4.59375 13.75H10.4062C12.9688 13.75 13.75 12.9688 13.75 10.4062V9.24375C13.75 7.0625 13.175 6.175 11.425 5.95625ZM7.5 11.7125C6.45625 11.7125 5.6125 10.8625 5.6125 9.825C5.6125 8.78125 6.4625 7.9375 7.5 7.9375C8.5375 7.9375 9.3875 8.7875 9.3875 9.825C9.3875 10.8688 8.54375 11.7125 7.5 11.7125ZM4.59375 5.9C4.54375 5.9 4.5 5.9 4.45 5.9V5.175C4.45 3.34375 4.96875 2.125 7.5 2.125C10.0312 2.125 10.55 3.34375 10.55 5.175V5.90625C10.5 5.90625 10.4563 5.90625 10.4062 5.90625H4.59375V5.9Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockedIcon);
export default __webpack_public_path__ + "static/media/lockedIcon.bd8fd846ebbc04039275c4f13a7d6077.svg";
export { ForwardRef as ReactComponent };